<template>
    <svg class="line" height="5" width="400">
    <polyline points="0,0 400,2.5 0,5"/>
</svg>

</template>

<script>
export default {
    name: 'tapered-line',
}
</script>

<style>
  svg.line {
    fill: #922610;
    /* Stroke is necessary for good antialiasing in Chrome. */
    stroke: #922610;
    margin-top: 0.6em;
    margin-bottom: 0.35em;
  }
</style>